export enum UploadDataType {
  SampleInfo = 0,
  PlanktonSurveyResult = 1,
  NutrientSurveyResult = 2,
  SedimentQualityResult = 3,
  HeavyMetals = 4,
  PetroleumHydrocarbons = 5,
}
